export default "__VITE_ASSET__D0QQ118T__"